import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, TrendingUp, Folder, Radar, Menu, X } from "lucide-react";
import {
  platformLinks,
  platformGroups,
  isPlatformLinkActive,
} from "@/utils/platformNavigation";
export function MobileNavBar() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const primary = [
    platformLinks[0],
    platformLinks[1],
    platformLinks[2],
    platformLinks[5],
  ];
  const icons = [Home, TrendingUp, Folder, Radar];
  return (
    <>
      {open && (
        <div className="fixed inset-x-3 bottom-24 z-50 max-h-[calc(100dvh-7rem)] overflow-y-auto rounded-2xl border bg-background p-3 shadow-xl lg:hidden">
          <div className="mb-2 flex items-center justify-between">
            <p className="font-bold">Explore PokeLlama</p>
            <button
              aria-label="Close more navigation"
              className="min-h-11 min-w-11"
              onClick={() => setOpen(false)}
            >
              <X className="mx-auto" />
            </button>
          </div>
          <nav
            aria-label="More platform tools"
            className="grid grid-cols-2 gap-2"
          >
            {[{label:"Home",links:[platformLinks[0]]}, ...platformGroups, {label:"Shop & community",links:platformLinks.slice(6)}].map(group => (
              <section key={group.label} className="col-span-2 border-t pt-2">
                <h2 className="mb-1 px-3 text-xs font-bold uppercase tracking-wider text-muted-foreground">{group.label}</h2>
                <div className="grid grid-cols-2 gap-2">
                  {group.links.map(link => <Link key={link.href} to={link.href} aria-current={isPlatformLinkActive(link.href, pathname) ? "page" : undefined} onClick={() => setOpen(false)} className="flex min-h-12 items-center rounded-xl bg-muted px-3 py-2 text-sm font-semibold">{link.label}</Link>)}
                </div>
              </section>
            ))}
          </nav>
          <Link
            to="/profile"
            className="mt-2 flex min-h-11 items-center px-3 text-sm font-semibold"
            onClick={() => setOpen(false)}
          >
            Profile & Settings
          </Link>
        </div>
      )}
      <nav
        aria-label="PokeLlama mobile"
        className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-5 border-t bg-background px-1 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] lg:hidden"
      >
        {primary.map((link, i) => {
          const Icon = icons[i];
          return (
            <Link
              key={link.href}
              to={link.href}
              onClick={() => setOpen(false)}
              aria-current={
                isPlatformLinkActive(link.href, pathname) ? "page" : undefined
              }
              className={`flex min-h-12 min-w-0 flex-col items-center justify-center gap-1 rounded-xl text-[11px] font-semibold ${isPlatformLinkActive(link.href, pathname) ? "bg-holo-blue/15 text-sky-800 dark:text-sky-300" : "text-muted-foreground"}`}
            >
              <Icon className="h-5 w-5" />
              {["Home", "Insights", "Binders", "Watch & Hunt"][i]}
            </Link>
          );
        })}
        <button
          type="button"
          aria-expanded={open}
          aria-label="More platform tools"
          onClick={() => setOpen(!open)}
          className="flex min-h-12 flex-col items-center justify-center gap-1 text-[11px] font-semibold"
        >
          <Menu className="h-5 w-5" />
          More
        </button>
      </nav>
    </>
  );
}

